import { useTranslation } from 'react-i18next';
import type { RowData } from '@tanstack/react-table';

import { ColumnMenu } from './ColumnMenu';
import type { DataTableInstance } from './features';

interface ColumnSelectorProps<T extends RowData> {
    table: DataTableInstance<T>;
}

/** The column menu for a DataTable, from the table's own hideable columns. */
export default function ColumnSelector<T extends RowData>({ table }: ColumnSelectorProps<T>) {
    const { t } = useTranslation();
    const columns = table
        .getAllColumns()
        .filter((column) => column.getCanHide())
        .map((column) => {
            const header = column.columnDef.header;
            return {
                id: column.id,
                label:
                    typeof header === 'string'
                        ? header
                        : column.id || t('organisms.dataTable.column'),
                visible: column.getIsVisible(),
            };
        });

    return (
        <ColumnMenu
            columns={columns}
            onToggle={(columnId, visible) => table.getColumn(columnId)?.toggleVisibility(visible)}
        />
    );
}
